@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  /**
   *
   * @param {AuthenticationService} _authenticationService
   */
  constructor(private readonly _authenticationService: UserContextService) {}

  /**
   * Add auth header with jwt if user is logged in and request is to api url
   * @param request
   * @param next
   */
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const currentUser = this._authenticationService.currentUser;
    const token = currentUser?.token || null;
    const isLoggedIn = !!token;

    // const isApiUrl = request.url.startsWith(environment.API_DOMAINS.SERVICIOS) || request.url.startsWith(environment.API_DOMAINS.USUARIOS) ;
    const isApiUrl1 = request.url.startsWith(environment.API_DOMAINS.URL_CANDIDATOS_API);
    const isApiUrl2 = request.url.startsWith(environment.API_DOMAINS.URL_COMUNES_API);
    const isApiUrl3 = request.url.startsWith(environment.API_DOMAINS.URL_SOLICITUDES_API);
    const isApiUrl4 = request.url.startsWith(environment.API_DOMAINS.URL_USERS_API);

    if (isLoggedIn && (isApiUrl1 || isApiUrl2 || isApiUrl3 || isApiUrl4)) {
      let agregaTokenURL = true;
      const txtUrlsExcluidas = ['.s3.amazonaws.com'];
      // Determina si a la url no se le debe agregar el token
      for (const txt of txtUrlsExcluidas) {
        if (request.url.split(txt).length > 1) {
          agregaTokenURL = false;
          break;
        }
      }

      if (agregaTokenURL) {
        request = request.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`,
          },
        });
      }
    }

    return next.handle(request);
  }
}
import { inject, Injectable } from '@angular/core';
import {
  HttpInterceptorFn,
  HttpRequest,
  HttpHandlerFn,
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
} from '@angular/common/http';
import { catchError, from, Observable, switchMap, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { UserContextService } from '../context/user.context';
import { StorageService } from '../services/storage.service';
import { GLOBALS } from '../constants/globals.constants';
import { AuthService } from '../../services/auth.service';

/**
 * Interceptor funcional para `provideHttpClient(withInterceptors([jwtInterceptorFn]))`.
 * Reemplaza/acompaña al interceptor de clase para ser compatible con HttpClient funcional.
 */
export const jwtInterceptorFn: HttpInterceptorFn = (request, next) => {
  const router = inject(Router);
  const cx = inject(AuthService);

  const isApiUrl = [
    environment.API_DOMAINS.URL_CANDIDATOS_API,
    environment.API_DOMAINS.URL_COMUNES_API,
    environment.API_DOMAINS.URL_SOLICITUDES_API,
    environment.API_DOMAINS.URL_USERS_API,
  ].some((url) => request.url.startsWith(url));

  const PUBLIC_ENDPOINTS = [
    '.s3.amazonaws.com',
    '/getUrlDocCartaOferta/',
    '/verificarFC',
    '/verificarCandidato',
    '/getSignedUrl',
  ];
  const isExcluded = PUBLIC_ENDPOINTS.some((txt) => request.url.includes(txt));

  if (!isApiUrl || isExcluded) return next(request);

  const candToken = sessionStorage.getItem(GLOBALS.SP_CANDIDATO_TOKEN_KEY);
  if (candToken) {
    return next(request.clone({ setHeaders: { Authorization: `Bearer ${candToken}` } }));
  }

  const currentToken = cx.getToken();

  // Sin sesión activa: dejar pasar sin token (endpoints públicos del candidato)
  if (!currentToken) {
    return next(request);
  }

  const addTokenAndCall = (token: string) => {
    const req = request.clone({ setHeaders: { Authorization: `Bearer ${token}` } });
    return next(req).pipe(
      catchError((error: any) => {
        if (error?.status === 401) {
          router.navigate(['/auth'], { queryParams: { reason: 'session_expired' } });
        }
        return throwError(() => error);
      }),
    );
  };

  if (cx.isTokenNoValid()) {
    return from(cx.refreshToken()).pipe(
      switchMap(async () => {
        await cx.updateTokenInContext();
        return cx.getToken();
      }),
      switchMap((token) => addTokenAndCall(token)),
      catchError(() => {
        router.navigate(['/auth'], { queryParams: { reason: 'session_expired' } });
        return throwError(() => new Error('Sesión expirada'));
      }),
    );
  }

  return addTokenAndCall(currentToken);
};
